import type { ReactNode } from "react";

/**
 * The one keyboard-hint chip, shared by every control that shows its shortcut
 * (GRA-126): a small bordered box beside the label, never a run-on suffix
 * baked into the label text ("TrendT", "FibF"). Borders in `currentColor` so
 * it always matches the label's own state color (muted at rest, accent when
 * armed/selected) without a second color prop to keep in sync.
 *
 * Hidden below `sm`: a keyboard shortcut is meaningless on a touch screen, and
 * the chip is one more thing to clip on a 390px row that a tap already
 * operates just as well without it.
 */
export function Kbd({ children, className = "" }: { children: ReactNode; className?: string }) {
  return (
    <kbd
      className={`ml-1.5 hidden rounded border border-current/30 px-1 py-0.5 text-[0.65em] font-mono leading-none opacity-70 sm:inline-block ${className}`}
    >
      {children}
    </kbd>
  );
}
